import React, { ReactElement } from "react";
import styles from "./styles.module.scss"
import { Box, Grid } from "@mui/material";
import { Translate } from "react-redux-i18n";
import { useAppDispatch } from "redux/hooks";
import { openDialog } from "redux/dialog/dialogSlice";

export default function DrawerContent(): ReactElement {
  const dispatch = useAppDispatch()
  return (
    <Box className={styles.drawerContentContainer}>
      <Box className={styles.grid}>
        <Grid container className={styles.gridContainer}>
          <Grid item lg={12} className={styles.gridItem}>
            <Box
              onClick={() => dispatch(openDialog({ type: "terms" }))}
              className={styles.termsLink}
            >
              <Translate value="content.terms" />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}